// Q9 S5 — Shared relative-time formatter for the auto-save badge.
//
// Spec format (docs/specs/visit-report-save-state.md §"Auto-saved Xs ago"
// badge / Granularity):
//   0-59s   → "{N}s ago"
//   60s-1h  → "{N}m ago"
//   > 1h    → "at HH:MM" (degrade to absolute — relative timestamp gets
//             confusing once a carer has been on the wizard for over an
//             hour).
//
// Existing helpers in NotificationsDrawer.tsx + RiskCriticalBanner.tsx use
// minute-resolution only (notifications never need second resolution).
// They stay separate for now; if a future refactor unifies the family
// of relative-time helpers, that's a cleanup task — out of scope here.

/** Render a Date as a save-badge-style relative-time string. */
export function formatRelativeSaveTime(timestamp: Date, now: Date = new Date()): string {
  const diffMs = now.getTime() - timestamp.getTime();
  const diffSeconds = Math.max(0, Math.floor(diffMs / 1000));
  if (diffSeconds < 60) return `${diffSeconds}s ago`;
  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  // > 1h — degrade to absolute. Locale-friendly HH:MM (24h or 12h depending
  // on the user's locale; Intl handles it).
  return `at ${timestamp.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })}`;
}
